module.exports = __webpack_public_path__ + "static/VIDEO_ASK.7a785904.svg";